mainApp.directive('socketsInformation', function () {
	return {
		scope: {
			siteId: '<',
			interval: '<',
			miniMode: '<',
			smallMode: '<',
		},
		templateUrl: '/public/directives/socketsInformation.html',
		controller: ['$scope', '$timeout', 'IntervalService', function($scope, $timeout, IntervalService) {

			$scope.HA_STATUS = {
				'READY': 'ready',
				'NOT_READY': 'issues',
				'OK': 'ok',
				'FAIL': 'issues',
			};

			$scope.$watch('siteId', () => {
				updateSocketsStats();
			});

			let updateSocketsStats = () => {
				if ($scope.siteId || $scope.siteId === 0) {

					resetSiteHaStatusIfNeeded()

					// getSiteStatus once, even if there is an interval, because the interval only starts after the first timeout
					getSiteStatus();

					if ($scope.interval){
						IntervalService.dynamicInterval(getSiteStatus, $scope.$id, 'socketInformationGetSiteStatus', false);
					}
				}
			}

			let getSiteStatus = () => {
				store.fetch({
					path: '/getSiteStatus?siteId=' + $scope.siteId,
					success: (data) => {
						if (data) {
							$scope.siteHaStatus = data;
							$scope.$digest();
						}
					}
				});
			}

			angular.element(document).ready(() => {
				updateSocketsStats($scope.siteId);
			});

			$scope.$on('$destroy',  () => {
				IntervalService.cancelDynamicInterval($scope.$id, 'socketInformationGetSiteStatus');
			});

			$scope.showSiteHaStatus = () => {
				return $scope.siteHaStatus?.socketStatuses?.primary && $scope.siteHaStatus.socketStatuses?.secondary;
			}

			let resetSiteHaStatusIfNeeded = () => {
				$scope.siteHaStatus = {
					siteReadiness : 'NOT_READY',
					wanConnectivity: 'FAIL',
					SiteSubStatus : 'FAIL',
					SiteSubStatus : 'FAIL',
					socketStatuses: {
						primary: null,
						secondary: null,
						siteId: $scope.siteId,
					},
				}
			}
		}]
	}
});
